import { Button, Stack, Typography } from '@mui/material';
import { FormContainer, PasswordElement, TextFieldElement } from 'react-hook-form-mui';
import { makeStyles } from 'tss-react/mui';
import AuthRequestStatus from '../../../enums/AuthRequestStatus';
import { LoginRequest } from '../../../sic-lib/types/Auth';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { requestToken } from '../../../store/users';
import AxiosErrorAlert from '../Alerts/AxiosErrorAlert';
import ButtonLoading from '../ButtonLoading';

export default function FormLogin() {
    const dispatch = useAppDispatch();
    const { classes } = useStyles();

    const authStatus = useAppSelector(state => {
        return (
            state.user?.authStatus || {
                requestStatus: AuthRequestStatus.none,
                error: null,
            }
        );
    });

    const handleSubmit = (loginRequest: LoginRequest | undefined) => {
        if (loginRequest) {
            dispatch(
                requestToken({ username: loginRequest.username, password: loginRequest.password }),
            );
        }
    };

    return (
        <FormContainer<LoginRequest> onSuccess={handleSubmit}>
            <Stack direction="column" justifyContent="center" spacing={2}>
                <Typography variant="h4" textAlign="center" mb={2}>
                    Log In
                </Typography>
                <TextFieldElement
                    label="Username"
                    name="username"
                    required
                    validation={{
                        minLength: {
                            value: 2,
                            message: 'User Name is too short.',
                        },
                        maxLength: {
                            value: 250,
                            message: 'User Name is too long.',
                        },
                        pattern: {
                            value: /^[a-zA-Z0-9-._@+](?:[a-zA-Z0-9-._@+ ]*[a-zA-Z0-9-._@+])?$/,
                            message: 'User Name contains invalid characters.',
                        },
                    }}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <PasswordElement
                    label="Password"
                    name="password"
                    required
                    validation={{
                        maxLength: {
                            value: 250,
                            message: 'Password is too long.',
                        },
                        pattern: {
                            value: /^(?=.*\d).{6,}$/,
                            message:
                                'Password must be at least 6 characters and contain a number and a letter.',
                        },
                    }}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                {authStatus.error && <AxiosErrorAlert error={authStatus.error} />}
                <ButtonLoading
                    isLoading={authStatus.requestStatus === AuthRequestStatus.active}
                    isError={authStatus.requestStatus === AuthRequestStatus.error}
                    isSuccess={authStatus.requestStatus === AuthRequestStatus.authSuccess}
                    type="submit"
                    color="primary"
                    variant="contained"
                    size="large"
                    fullWidth
                >
                    Log in
                </ButtonLoading>
                <Button
                    variant="text"
                    href="https://6scentral.com/ResetPWD"
                    target="_blank"
                    fullWidth
                >
                    Reset password
                </Button>
            </Stack>
        </FormContainer>
    );
}

const useStyles = makeStyles()({
    root: {},
});
